import COLORS from '@/constants/colors';
import CheckOutlinedIcon from '@mui/icons-material/CheckOutlined';
import CloseOutlinedIcon from '@mui/icons-material/CloseOutlined';
import EditOutlinedIcon from '@mui/icons-material/EditOutlined';
import { Button, Popper, Stack, TextField, Typography } from '@mui/material';
import InputAdornment from '@mui/material/InputAdornment';
import { useEditPriceViewController } from './EditPriceViewController';

export function EditablePrice(props: {
  productId: string;
  skuId: string;
  price: string;
}) {
  const { uiState, actions, references } = useEditPriceViewController({
    productId: props.productId,
    skuId: props.skuId,
    price: props.price,
  });

  return (
    <Stack direction={'row'} alignItems={'center'}>
      {!uiState.open && (
        <>
          <Button onClick={actions.onClickedEditPrice}>
            <EditOutlinedIcon />
          </Button>
          <Typography>${props.price}</Typography>
        </>
      )}

      <TextField
        sx={{ display: uiState.open ? 'unset' : 'none' }}
        value={uiState.priceText}
        ref={references.anchorEl}
        InputProps={{
          startAdornment: <InputAdornment position="start">$</InputAdornment>,
        }}
        onChange={actions.onPriceTextChanged}
      />

      <Popper
        open={uiState.open}
        placement="bottom-end"
        anchorEl={references.anchorEl.current}
        sx={{ display: 'flex', direction: 'row', gap: '4px', pt: '8px' }}
      >
        <Button
          onClick={actions.onClickedSavePrice}
          sx={buttonStyle(uiState.isInvalidPrice)}
        >
          <CheckOutlinedIcon />
        </Button>
        <Button onClick={actions.onClickedCancelEdit} sx={buttonStyle(false)}>
          <CloseOutlinedIcon />
        </Button>
      </Popper>
    </Stack>
  );
}

const buttonStyle = (disabled: boolean) => ({
  border: `1px solid ${COLORS.gray_300}`,
  background: disabled ? COLORS.gray_200 : 'white',
  '&:hover': { backgroundColor: COLORS.gray_50 },
});
